module.exports = __webpack_public_path__ + "static/media/HypothesesFluid.087257e0.png";